"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = processStyle;
/*  weak */
/**
 * pipes a style object through a list of plugins
 *
 * @param {Object} style - style object to process
 * @param {Object} meta - additional meta data
 * @param {Function[]} plugins - plugins used to process style
 * @return {Object} processed style
 */
function processStyle(style, meta, plugins) {
  return plugins.reduce(function (processedStyle, plugin) {
    return plugin(processedStyle, meta);
  }, style);
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ../~/fela/lib/utils/processStyle.js
// module id = 439
// module chunks = 0